import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import ReactJsonView from '@microlink/react-json-view'
import updateHistory from "./utils/updateHistory"
import { HISTORY_TYPE, IHistoryStep } from "src/modules/pe-landing-module/data/interfaces"
import { __ } from "src/libs/utilities"
import useSelectedContent from "src/modules/pe-landing-module/hooks/useSelectedContent"

// https://www.npmjs.com/package/react-json-view
/* Protopia Ecosystem component */ 

const LandingDataPanel = () : JSX.Element => {
    const currentLanding    = useLandingStore( (state: ILandingStore) => state.currentLanding )  
    const hoverElement      = useLandingStore( (state: ILandingStore) => state.hoverElement ) 
    const curEditModalData  = useLandingStore( (state: ILandingStore) => state.currentEditData ) 
    const selectedData      = useSelectedContent()
    const onEdit = ( edit: any ) => {
        const step: IHistoryStep = {
            data: edit.existing_src,
            prevData: edit.updated_src,
            type: HISTORY_TYPE.SECTION,
            title : __( "Edit source JSON" ),
        } 
        updateHistory(step, edit.updated_src)
    }
    return <div className="landing-edit-layer">
        <div className="panel-list-2 overflow-y-auto"> 
            <div className="small letter-spacing-1 px-2">
                {__("Landing data")}
            </div>
             <div className="p-0"> 
                <ReactJsonView 
                    src={currentLanding} 
                    theme="codeschool" 
                    displayObjectSize
                    onEdit={onEdit}
                    displayDataTypes={false}
                    collapsed
                    indentWidth={2}
                    collapseStringsAfterLength={20}
                    quotesOnKeys={false}
                />
             </div>
            <div className="small letter-spacing-1 mt-1 px-2">
                {__("Selected element data")}
            </div>
             <div className="p-0"> 
                <ReactJsonView 
                    src={ selectedData } 
                    theme="codeschool" 
                    displayObjectSize 
                    displayDataTypes={false}
                    collapsed
                    indentWidth={2}
                    collapseStringsAfterLength={20}
                    quotesOnKeys={false}
                />
             </div>
            <div className="small letter-spacing-1 mt-1 px-2">
                {__("Hover element data")}
            </div>
             <div className="p-0"> 
                <ReactJsonView 
                    src={ hoverElement || {} } 
                    theme="codeschool" 
                    displayObjectSize 
                    displayDataTypes={false}
                    collapsed={false}
                    indentWidth={2}
                    // collapseStringsAfterLength={20}
                    quotesOnKeys={false}
                />
             </div>
            <div className="small letter-spacing-1 mt-1 px-2">
                {__("Landing edit data modal")}
            </div>
             <div className="p-0"> 
                <ReactJsonView 
                    src={ curEditModalData || {} } 
                    theme="codeschool" 
                    displayObjectSize 
                    displayDataTypes={false}
                    collapsed={false}
                    indentWidth={2} 
                    quotesOnKeys={false}
                />
             </div>
        </div> 
    </div>

} 
export default LandingDataPanel
